import axios from "axios";

export default class Params {

  constructor(){
    this.development = 'https://dovimpruebas.uwcolombia.org/formacion/controller/';
    this.demo = 'https://demos.uwcolombia.org/formacion/controller/';
    this.production = 'https://uwcolombia.org/formacion/controller/';
    this.apidevelompent = 'https://dovimpruebas.uwcolombia.org/api/';
    this.apiproduction = 'https://uwcolombia.org/api/';
    this.controller = this.development;
    this.api = this.apidevelompent;
    this.host = 'https://' + window.location.host;

    this.document_type = [
      {label: 'Cédula de Ciudadanía', value:'CC'},
      {label: 'Cédula de Extranjería', value: 'CE'},
      {label: 'Pasaporte', value: 'PS'},
      {label: 'NUIP', value: 'NUIP'},
      {label: 'Permiso Especial de Permanencia', value: 'PEP'},
      {label: 'Otro', value: 'otro'}
    ];

    this.location = [
      {label: 'Urbana', value: 'urbana'},
      {label: 'Rural', value: 'rural'}
    ];

    this.gender = [
      { label: 'Hombre', value: 'hombre' },
      { label: 'Mujer', value: 'mujer' },
      { label: 'Otro', value: 'otro' }
    ];

    this.country = [
      { label: 'Colombia', value: 'Colombia' },
      { label: 'Argentina', value: 'Argentina' },
      { label: 'Bolivia', value: 'Bolivia' },
      { label: 'Brasil', value: 'Brasil' },
      { label: 'Chile', value: 'Chile' },
      { label: 'Canadá', value: 'Canadá' },
      { label: 'Costa Rica', value: 'Costa Rica' },
      { label: 'Cuba', value: 'Cuba' },
      { label: 'Ecuador', value: 'Ecuador' },
      { label: 'El Salvador', value: 'El Salvador' },
      { label: 'España', value: 'España' },
      { label: 'Estados Unidos', value: 'Estados Unidos' },
      { label: 'Francia', value: 'Francia' },
      { label: 'Guatemala', value: 'Guatemala' },
      { label: 'Haití', value: 'Haití' },
      { label: 'Honduras', value: 'Honduras' },
      { label: 'México', value: 'México' },
      { label: 'Nicaragua', value: 'Nicaragua' },
      { label: 'Panamá', value: 'Panamá' },
      { label: 'Paraguay', value: 'Paraguay' },
      { label: 'Perú', value: 'Perú' },
      { label: 'Portugal', value: 'Portugal' },
      { label: 'Republica Dominicna', value: 'Republica Dominicna' },
      { label: 'Uruguay', value: 'Uruguay' },
      { label: 'Venezuela', value: 'Venezuela' },
      { label: 'Otro', value: 'Otro' }
    ];
  }

  department(){
    const frm = new FormData
    frm.append("action", "select")
    frm.append("object", "departamentos")
    frm.append("context", "general")
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php', frm).then(res => {
        if(res.data.state){
          resolve(res.data.options)
        }else{
          resolve([])
        }
      })
    })
  }

  city(value){
    const frm = new FormData
    frm.append("action", "selectparam")
    frm.append("object", "ciudades")
    frm.append("context", "general")
    frm.append("value", value)
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php', frm).then(res => {
        if(res.data.state){
          resolve(res.data.options)
        }else{
          resolve([])
        }
      })
    })
  }

  age(){
    const frm = new FormData
    frm.append("action", "select")
    frm.append("object", "caredades")
    frm.append("context", "impacto")
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php',frm).then(res => { 
        if(res.data.state){
          resolve(res.data.options) 
        }else{
          resolve([])
        }
      });
    });
  }

  roles(age){
    const frm = new FormData
    frm.append("action", "select")
    frm.append("object", "carcargos")
    frm.append("context", "impacto")
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php',frm).then(res => { 
        if(res.data.state){
          const item = [];
          res.data.options.forEach(element => {
            if(age >= 4){
              item.push(element);
            }else if(age < 4){
              if(element.value == 5 || element.value == 8){
                item.push(element);
              }
            }         
          });
          resolve(item) 
        }else{
          resolve([])
        }
      });
    });
  }

  trajectory(role, age){
    const frm = new FormData
    frm.append("action", "selectparam")
    frm.append("object", "trayectorias")
    frm.append("context", "impacto")
    frm.append("value", role)
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php', frm).then(res => {
        if(res.data.state){
          const item = [];
          res.data.options.forEach(element => {
            if(age == 1 && element.value == 3){
              item.push(element);
            }else if(age == 2 && (element.value > 3 && element.value < 10)){
              item.push(element);
            }else if(age == 3 && (element.value >= 9 && element.value <= 14)){
              item.push(element);
            }else if(age > 3 && role == 5 && [13,14,28].includes(element.value)){
              item.push(element);
            }else if(role == 8 && element.value == 17){
              item.push(element);
            }else if(age > 3 && role != 5){
              item.push(element);
            }
          })
          
          resolve(item)
        }else{
          resolve([])
        }
      })
    })
  }

  formation(age){
    const frm = new FormData
    frm.append("action", "select")
    frm.append("object", "carformacion")
    frm.append("context", "impacto")
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php',frm).then(res => { 
        if(res.data.state){
          const item = []
          res.data.options.forEach(element => {
            if(age == 1 && element.value == 1){
              item.push(element);
            }else if(age == 2 && [1,9].includes(element.value)){
              item.push(element);
            }else if(age == 3 && [1,9].includes(element.value)){
              item.push(element);
            }else if(age > 3){
              item.push(element);
            }
          })
          resolve(item) 
        }else{
          resolve([])
        }
      });
    });
  }

  institutiontype(role, age){
    const frm = new FormData
    frm.append("action", "select")
    frm.append("object", "tipoinstitucion")
    frm.append("context", "impacto")
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php',frm).then(res => { 
        if(res.data.state){
          const item = [];
          res.data.options.forEach(element => {            
            if(role == 5 && age == 1 && [1,6,7].includes(element.value)){
              item.push(element);
            }else if(role == 5 && (age == 2 || age == 3) && [2,5].includes(element.value)){
              item.push(element);
            }else if(role == 5 && age == 2 && [2,5].includes(element.value)){
              item.push(element);
            }else if(role == 5 && age > 3 && element.value == 8){
              item.push(element);
            }else if((role == 4 || role == 7) && age > 3 && [3,4].includes(element.value)){
              item.push(element);
            }else if(role == 6 && age > 3 && element.value == 8){
              item.push(element);
            }else if([1,2,3].includes(role) && age > 3 && [1,2,5,7].includes(element.value)){
              item.push(element);
            }else if(role == 8 && element.value == 8){
              item.push(element);
            }
          })
          resolve(item) 
        }else{
          resolve([])
        }
      });
    });
  }

  institutions(value){
    const frm = new FormData
    frm.append("action", "selectparam")
    frm.append("object", "instituciones")
    frm.append("context", "impacto")
    frm.append("value", value)
    return new Promise((resolve) => {
      axios.post(this.controller + 'general.php', frm).then(res => {
        if(res.data.state){
          resolve(res.data.options)
        }else{
          resolve([])
        }
      })
    })
  }

}